
  (function () {
    /**
     * Checks if the user is under any of the specified privacy regimes.
     * @returns {boolean} True if any specified regime is applicable; otherwise, false.
     */
    function needsToShowBanner() {
      const regimesToCheck = ['CPRA', 'CPA', 'CDPA', 'NEVADA_SB220'];
      const userRegimes = window.airgap.getRegimes();
      return regimesToCheck.some((regime) => userRegimes.has(regime));
    }

    /**
     * Check if the banner should be shown by evaluating the presence of 'transcend-cookie'
     * and whether the banner is needed based on privacy regimes.
     * @returns {boolean} True if banner should be shown, otherwise false.
     */
    function shouldShowPrivacyBanner() {
      const hasSeenNotice = localStorage.getItem('_x-pR1v_bnNR') === 'true';
      return needsToShowBanner() && !hasSeenNotice;
    }

    function triggerPrivacyBannerCheck() {
      window.dispatchEvent(
        new CustomEvent('privacy-banner-check', {
          detail: {
            shouldShowPrivacyBanner: shouldShowPrivacyBanner(),
            privacyHtmlContent: `
              <div class="privacy-banner">
                <div class="privacy-container">
                  <div class="privacy-text">
                    <p>
                      Our website uses tracking technologies that are described in our Cookie Policy accessible
                      <a href="https://privacy.drsquatch.com/policies/en/?name=cookie-policy">here</a>.
                      To manage these settings, visit
                      <a href="#privacy">Your Privacy Choices</a>.
                      By continuing to browse our site, you agree to our
                      <a href="https://privacy.drsquatch.com/policies/en/?name=privacy-policy">Privacy Policy</a>,
                      <a href="https://privacy.drsquatch.com/policies/en/?name=cookie-policy">Cookie Policy</a>, and
                      <a href="https://www.drsquatch.com/pages/terms-of-use">Terms of Use</a>.
                    </p>
                  </div>
                  <div class="privacy-button">
                    <a href="#privacy-acknowledged">OK</a>
                  </div>
                </div>
              </div>

              <style>
              .privacy-banner {
                position: fixed;
                bottom: 0;
                background-color: rgba(33, 33, 33, 0.9);
                color: white;
                z-index: 1100;
                width: 100%;
              }

              .privacy-container {
                padding: 1rem;
                display: grid;
                gap: 1rem;
              }

              @media (min-width: 768px) {
                .privacy-container {
                  grid-template-columns: auto auto;
                }
              }

              .privacy-text p {
                font-family: 'founders-grotesk', Arial, sans-serif;
                font-size: 0.75rem;
              }

              .privacy-text a {
                color: #367f91;
                text-decoration: underline;
              }

              .privacy-text a:hover {
                text-decoration: none;
              }

              .privacy-button {
                margin-top: auto;
                margin-bottom: auto;
                min-width: 8rem;
              }

              .privacy-button a {
                font-family: 'founders-grotesk', Arial, sans-serif;
                font-weight: 600;
                border-color: #367f91;
                display: flex;
                justify-content: center;
                padding: 0.5rem;
                text-align: center;
                border-radius: 0.5rem;
                background-color: #367f91;
                color: white;
                text-decoration: none;
              }

              .privacy-button a:hover {
                background-color: #212121;
                border-color: #212121;
                color: white;
              }
              </style>
            `,
          },
        }),
      );
    }

    // Add event listener for component mounted
    window.addEventListener('privacy-banner-mounted', triggerPrivacyBannerCheck);

    let previousHash = window.location.hash;
    // Logic to open Transcend Consent Manager when a user clicks on the footer hyperlink
    function checkHashForPrivacy() {
      if (window.location.hash === '#privacy') {
        window.transcend.showConsentManager({
          viewState: 'DoNotSellExplainer',
        });
        // Remove the hash from the URL
        history.replaceState(
          null,
          null,
          window.location.pathname + window.location.search + previousHash,
        );
      } else if (window.location.hash === '#privacy-acknowledged') {
        localStorage.setItem('_x-pR1v_bnNR', 'true');
        // Remove the hash from the URL
        history.replaceState(
          null,
          null,
          window.location.pathname + window.location.search + previousHash,
        );
        triggerPrivacyBannerCheck();
      }
    }
    window.addEventListener('hashchange', checkHashForPrivacy);
  })();

